export default [
  {
    path: '/profile',
    name: 'profile',
    component: () => import('@/views/admin/profile.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Profile',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Edit Profile', active: true }
      ]
    }
  },   
]
